import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getBikeAll } from '../sellThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
const SLICE_NAME = 'bikeAll';

export const bikeAllSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getBikeAll });
    },
});

export const bikeAll = bikeAllSlice.reducer;
